import type { CertificateTemplateConfig } from '../types';

const DEFAULT_TYPE = 'CERTIFICATES';
const DEFAULT_NAME = 'STANDARD';

export const parseCertificateTemplateConfig = (
  blobText: string | null | undefined
): CertificateTemplateConfig => {
  const defaultConfig: CertificateTemplateConfig = {
    type: DEFAULT_TYPE,
    name: DEFAULT_NAME
  };

  if (!blobText) return defaultConfig;

  try {
    const parsed = JSON.parse(blobText);
    return {
      type: typeof parsed?.type === 'string' ? parsed.type : DEFAULT_TYPE,
      name: typeof parsed?.name === 'string' ? parsed.name : DEFAULT_NAME,
      version: parsed?.version
    };
  } catch {
    return defaultConfig;
  }
};

export const stringifyCertificateTemplateConfig = (
  config: CertificateTemplateConfig
): string => {
  return JSON.stringify(config);
};
